import { FC } from 'react';

import cn from 'classnames';

import {
	FISHPLACE_INFO_EMAIL_URL,
	FISHPLACE_PHONE_URL,
	TG_CHANNEL_FISHPLACE_URL,
	WHATSAPP_FISHPLACE_URL,
} from '@/constants/routes';

import styles from '@/components/ContactUs/ContactUsForm.module.scss';

type Props = {
	locale: string;
	translate: (arg: string) => string;
};

export const Contacts: FC<Props> = ({ locale, translate }) => {
	return (
		<div>
			<h2
				id="openoffice"
				className={cn(styles.sectionTitle, locale === 'ru' ? 'max-w-[40rem]' : 'max-w-[50rem]')}
			>
				{translate('contactus.open')} <br />
				{translate('contactus.a-digital-office')}
			</h2>
			<p className={styles.sectionSubtitle}>{translate('contactus.call-us-at')}</p>
			<a className={styles.tel} href={FISHPLACE_PHONE_URL}>
				+7 908 999 80 80
			</a>
			<ul className={styles.socials}>
				<li>
					<a href={TG_CHANNEL_FISHPLACE_URL} target="_blank" rel="noreferrer">
						<img src="/img/socials/telegram.svg" alt="Telegram" />
					</a>
				</li>
				<li>
					<a href={WHATSAPP_FISHPLACE_URL} target="_blank" rel="noreferrer">
						<img src="/img/socials/whatsapp.svg" alt="WhatsApp" />
					</a>
				</li>
				<li>
					<a href={FISHPLACE_INFO_EMAIL_URL} target="_blank" rel="noreferrer">
						<img src="/img/socials/email.svg" alt="Email" />
					</a>
				</li>
			</ul>
		</div>
	);
};
